/**
 * Safely format a date/timestamp value returned from GraphQL/Postgres.
 * Postgres returns timestamps in various formats; this handles all of them.
 *
 * @param {string|number|Date|null|undefined} val
 * @param {'date'|'datetime'} mode  – 'date' = date only, 'datetime' = date + time
 * @returns {string}  formatted string, or '—' when blank/invalid
 */
export function fmtDate(val, mode = 'date') {
  if (!val) return '—';
  // Postgres sometimes returns "2026-04-02 10:30:00+00" (space instead of T); an all-digit
  // string is epoch milliseconds
  const normalized = typeof val === 'string' ? (/^\d{11,}$/.test(val) ? Number(val) : val.replace(' ', 'T')) : val;
  const d = new Date(normalized);
  if (isNaN(d.getTime())) return '—';
  if (mode === 'datetime') {
    return d.toLocaleString('en-IN', {
      day: '2-digit', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit', hour12: true,
    });
  }
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}
